import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material"
import HelpOutlineIcon from "@mui/icons-material/HelpOutlineOutlined"

import { WW_BLUE } from "@/theme/tokens"

import TourList from "./TourList.jsx"


export default function WelcomeDialog({ open, tours, onStart, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth aria-labelledby="tour-welcome-title">
      <DialogTitle id="tour-welcome-title" sx={{ color: WW_BLUE, fontWeight: 700 }}>
        Welcome to METEO TRACKER
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 1.5 }}>
          Short interactive tutorials guide you step by step through the main workflows. Pick one
          to start:
        </Typography>
        <TourList tours={tours} onStart={onStart} />
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 1.5, color: "text.secondary" }}>
          <Typography variant="caption">You can open the tutorials again at any time via</Typography>
          <HelpOutlineIcon sx={{ fontSize: 16, color: WW_BLUE }} />
          <Typography variant="caption">in the top bar.</Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} sx={{ color: WW_BLUE }}>
          Maybe later
        </Button>
      </DialogActions>
    </Dialog>
  )
}
